import { z } from "zod";

const typeCode = z.enum([
  "PESEL",
  "PASSPORT",
  "IDCARD",
  "RESIDENCEPERMIT",
  "NATIONALIDCARD",
  "IDCARD",
]);

export const serverResponse = z.object({
  person: z.object({
    verified: z.boolean(),
    firstName: z.string(),
    lastName: z.string(),
    registrations: z
      .array(
        z.object({
          id: z.string(),
          typeCode,
          issuingCountry: z.string().optional(),
        }),
      )
      .optional(),
  }),
});
